import { MediaData } from '@app/shared/types/player';
import { Paragraph } from '@app/shared/ui/atoms/Common';

interface MediaProps extends Omit<MediaData, 'id' | 'src'> {
  onTrackClick: () => void;
}

export const Media = ({ title, description, onTrackClick }: MediaProps) => {
  return (
    <div
      className="px-2 py-[2px] text-start backdrop-blur-md bg-background/45 shadow-xl rounded-full cursor-pointer border border-white/50 "
      onClick={onTrackClick}
    >
      <Paragraph className="flex items-center gap-1 text-foreground/90" size="sm">
        <span className="text-3xl">🐼</span>
        {title} - {description}
      </Paragraph>
    </div>
  );
};
